import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ButtonWithSpinner, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import { validatePassword } from '@/general/helpers/helpers'

import InvalidPasswordError from './InvalidPasswordError'
import * as Styles from './styles'

const Security = ({ onChangePassword, changingPassword, errors, hasUsablePassword }) => {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [retypePassword, setRetypePassword] = useState('')
  const { t } = useTranslation()
  const [showNewPasswordsAreNotEqual, setShowNewPasswordsAreNotEqual] = useState(false)

  const handleChange = e => {
    const changeValue = {
      oldPassword: setOldPassword,
      newPassword: setNewPassword,
      retypePassword: setRetypePassword,
    }
    changeValue[e.target.name](e.target.value)
  }

  const formIsValid = () => {
    if (!hasUsablePassword) {
      return newPassword && retypePassword && newPassword === retypePassword && validatePassword(newPassword)
    }

    return (
      oldPassword && newPassword && retypePassword && newPassword === retypePassword && validatePassword(newPassword)
    )
  }

  const checkPasswordsAreNotEqual = () => {
    if (newPassword && retypePassword) {
      setShowNewPasswordsAreNotEqual(newPassword !== retypePassword)
    }

    return false
  }

  const showInvalidPasswordError = () => {
    return newPassword && retypePassword && newPassword === retypePassword && !validatePassword(newPassword)
  }

  const changePassword = () => {
    onChangePassword(oldPassword, newPassword, () => {
      setOldPassword('')
      setNewPassword('')
      setRetypePassword('')
    })
  }

  return (
    <Styles.Container>
      <Text type="bodyMRegular">{t('Elige la contraseña que usarás para acceder a tu cuenta')}</Text>
      {hasUsablePassword && (
        <InputWithLabel
          onChange={handleChange}
          value={oldPassword}
          fullWidth
          placeholder="******"
          label={t('Contraseña actual')}
          name="oldPassword"
          type="password"
          error={errors?.old_password?.[0]}
          helperText={errors?.old_password?.[0]}
        />
      )}
      <InputWithLabel
        onChange={handleChange}
        value={newPassword}
        fullWidth
        placeholder="******"
        label={t('Nueva contraseña')}
        name="newPassword"
        type="password"
        onBlur={checkPasswordsAreNotEqual}
        error={showNewPasswordsAreNotEqual}
      />
      <InputWithLabel
        onChange={handleChange}
        value={retypePassword}
        fullWidth
        placeholder="******"
        label={t('Confirmar nueva contraseña')}
        name="retypePassword"
        type="password"
        error={showNewPasswordsAreNotEqual}
        onBlur={checkPasswordsAreNotEqual}
        helperText={showNewPasswordsAreNotEqual && t('Las contraseñas no coinciden')}
      />
      <ButtonWithSpinner
        disabled={!formIsValid() || changingPassword}
        fullWidth
        onClick={changePassword}
        defaultLabel={t('Cambiar contraseña')}
        loadingLabel={t('Cambiando contraseña')}
      />
      {showInvalidPasswordError() && <InvalidPasswordError />}
    </Styles.Container>
  )
}

export default Security
